module.exports = __webpack_public_path__ + "static/media/python.7dd56190.svg";